export default __webpack_public_path__ + "static/media/slide-1.36ab6a41.png";